module.exports = __webpack_public_path__ + "static/media/IMG_2095.8adb4183.JPG";